/**
 * Renders a drop-down menu for filtering Ravens based on when the
 * most recent update was.
 * Rendered in GridPage.js
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';
import SelectDropDown from '../../common/SelectDropDown';

class TimeFilter extends PureComponent {
    render() {
        const { value, onChange } = this.props;

        const timeOptions = [
            { label: strings.all_time, value: "all", checked: value === "all" },
            { label: strings.last_month, value: "30d", checked: value === "30d" },
            { label: strings.last_week, value: "7d", checked: value === "7d" },
            { label: strings.last_two_days, value: "48h", checked: value === "48h" },
            { label: strings.last_day, value: "24h", checked: value === "24h" },
            { label: strings.last_hour, value: "1h", checked: value === "1h" },
        ];

        const handleChange = (index) => {
            const selectedOption = timeOptions[index];

            onChange({
                target: {
                    value: selectedOption.value
                }
            });
        };

        return (
            <div className="grid-options-period">
                <div className="grid-options-period-label">
                    {strings.score_options_period}
                </div>
                <SelectDropDown
                    options={timeOptions}
                    onChange={handleChange}
                    singleOnlySelection={true}
                    requiredSelection={true}
                    isDefaultOptional={true} 
                />
            </div>
        );
    }
}

TimeFilter.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default TimeFilter;